import { Injectable } from '@angular/core';
import { PoolParams, Pool, FetchResponse, PollFunction, IsCompleted } from './';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class PollingService {
    private poolMap = new Map<string, Pool>();
    readonly defaultPool: Pool;

    constructor() {
        this.defaultPool = this.buildPool({ id: 'defaultPool' });
    }

    public buildPool(params: PoolParams = {}): Pool {
        let pool = new Pool(params);
        if (this.poolMap.has(pool.id)) {
            throw new Error(`Pool with id "${pool.id}" already exists`);
        }
        this.poolMap.set(pool.id, pool);
        return pool;
    }

    public getOrBuildPool(params: PoolParams & { id: string }): Pool {
        const existing = this.poolMap.get(params.id);
        if (existing) {
            return existing;
        }
        return this.buildPool(params);
    }

    public addTask(pollFunction: PollFunction, isCompleted?: IsCompleted): Promise<any> | Observable<any> {
        return this.defaultPool.addTask(pollFunction, isCompleted);
    }

    public addUniquePoolTask(pollFunction: PollFunction, pool: Pool, isCompleted?: IsCompleted): Promise<any> | Observable<any> {
        return pool.addTask(pollFunction, isCompleted);
    }

    public addUrlTask(url: string, isCompleted?: IsCompleted): Promise<any> | Observable<any> {
        return this.addTask(this.buildUrlPollFunction(url), isCompleted);
    }

    public addUrlPoolTask(url: string, pool: Pool, isCompleted?: IsCompleted): Promise<any> | Observable<any> {
        return this.addUniquePoolTask(this.buildUrlPollFunction(url), pool, isCompleted);
    }

    private buildUrlPollFunction(url: string): PollFunction {
        return async () => {
            let r = await fetch(url);
            let fetchResponse: FetchResponse = {
                status: r.status,
                url: r.url,
                headers: r.headers,
                ok: r.ok,
                statusText: r.statusText,
                body: await r.text(),
            };
            try {
                fetchResponse.body = JSON.parse(fetchResponse.body);
            } catch (e) {}
            return fetchResponse;
        };
    }
}
